import React from 'react';
import {Modal, StyleSheet, View} from 'react-native';

function SlideUpModal({isVisible, children, heightPercent = '25%'}) {
  return (
    <Modal visible={isVisible} transparent={true} animationType="slide">
      <View style={[styles.modalContainer, {height: heightPercent}]}>{children}</View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  modalContainer: {
    marginTop: 'auto',
    backgroundColor: '#cdc8d5',
  },
});

export default SlideUpModal;
